export default "__VITE_ASSET__D7i9aELC__"